interface ServiceCardProps {
  icon: string;
  title: string;
  description: string;
  badge?: string;
}

export default function ServiceCard({ icon, title, description, badge }: ServiceCardProps) {
  return (
    <div className="group bg-background-50 border border-background-200/60 rounded-lg p-5 md:p-6 hover:border-primary-200/50 hover:shadow-[0_2px_12px_rgba(242,111,37,0.06)] transition-all duration-300 cursor-default relative">
      {badge && (
        <span className="absolute top-3 right-3 inline-flex items-center px-2 py-0.5 text-[10px] font-semibold tracking-wider uppercase rounded-full bg-primary-100 text-primary-600 whitespace-nowrap">
          {badge}
        </span>
      )}
      <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
        <i className={`${icon} text-lg`}></i>
      </div>
      <h3 className="text-base font-semibold text-foreground-900 font-heading mb-2 group-hover:text-primary-600 transition-colors duration-300">
        {title}
      </h3>
      <p className="text-sm text-foreground-600 leading-relaxed">
        {description}
      </p>
    </div>
  );
}